import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import {
  UNIFIED_FEED_DOMAIN_GLOBAL,
  UNIFIED_FEED_DOMAIN_SERVICE,
  UNIFIED_FEED_RESOURCES_DOMAIN,
} from 'constants/index';
import makeRequest from '../../utils/makeRequest';
import reducerRegistry from '../../reduxUtils/reducerRegistry';

const reducerName = 'toigames';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const FETCH_GAMES_DATA = createActionName('FETCH_GAMES_DATA');
export const FETCH_GAMES_FAILURE = createActionName('FETCH_GAMES_FAILURE');
export const RECEIVE_GAMELISTING_DATA = createActionName(
  'RECEIVE_GAMELISTING_DATA',
);
export const RECEIVE_METAWIDGET_DATA = createActionName(
  'RECEIVE_METAWIDGET_DATA',
);
export const RECEIVE_LEADERBOARD_DATA = createActionName(
  'RECEIVE_LEADERBOARD_DATA',
);
export const RECEIVE_STREAK_DATA = createActionName('RECEIVE_STREAK_DATA');
export const RECEIVE_PREVIOUSPUZZLE_DATA = createActionName(
  'RECEIVE_PREVIOUSPUZZLE_DATA',
);
export const RECEIVE_PUZZFILEDOWNLOAD_DATA = createActionName(
  'RECEIVE_PUZZFILEDOWNLOAD_DATA',
);
export const RECEIVE_PRACTICE_DATA = createActionName('RECEIVE_PRACTICE_DATA');
export const RECEIVE_GAMECONFIG_DATA = createActionName(
  'RECEIVE_GAMECONFIG_DATA',
);
export const RECEIVE_CROSSWORDSTATE_DATA = createActionName(
  'RECEIVE_CROSSWORDSTATE_DATA',
);
export const RECEIVE_SUDOKUSTATE_DATA = createActionName(
  'RECEIVE_SUDOKUSTATE_DATA',
);
export const RECEIVE_LOOPALOOPSTATE_DATA = createActionName(
  'RECEIVE_LOOPALOOPSTATE_DATA',
);
export const RECEIVE_LOCATIONGUESSERSTATE_DATA = createActionName(
  'RECEIVE_LOCATIONGUESSERSTATE_DATA',
);
export const RECEIVE_WHOISTHATSTATE_DATA = createActionName(
  'RECEIVE_WHOISTHATSTATE_DATA',
);
export const RECEIVE_FACTCHECKER_DATA = createActionName(
  'RECEIVE_FACTCHECKER_DATA',
);
export const RECEIVE_GAME_STATUS_DATA = createActionName(
  'RECEIVE_GAME_STATUS_DATA',
);

const GAMESLISTINGAPI = `/ufs-utility/toi-games/fetch/game/listing-with-status?pc=toi&pfm=web`;
const GAMESMETAWIDGETAPI = `/ufs-utility/toi-games/get/seo/details?pc=toi&pfm=web`;
const LEADERBOARDAPI = `/ufs-utility/toi-games/leaderboard/listing?pc=toi&pfm=web`;
const PUZZFILEDOWNLOADAPI = `/ufs-utility/toi-games/download/puzzle?pc=toi&pfm=web`;
const PRACTICEAPI = '/ufs-utility/toi-games/previous/puzzle?pc=toi&pfm=web';
const SYNCAPI = '/ufs-utility/toi-games/sso/sync';
const GAMESCONFIGAPI = `/ufs-utility/toi-games/fetch/game/config?pc=toi&pfm=web`;
const STREAKAPI = `/ufs-utility/toi-games/revamp/fetch/streak?pc=toi&pfm=web&fv=1300`;
const GAMESTATUSAPI = `/ufs-utility/toi-games/revamp/status/game?pc=toi&pfm=web`;
const FETCHCROSSWORDSTATE = `/ufs-utility/toi-games/get/paused/game?pc=toi&pfm=web`;
const SAVECROSSWORDSTATE = `/ufs-utility/toi-games/save/paused/game?pc=toi`;
const PREVIOUSPUZZLEAPI = `/ufs-utility/toi-games/previos/puzzle/status/widget?pc=toi&pfm=web&fv=1300`;

// action creators
function updateGamesData(data) {
  return {
    type: FETCH_GAMES_DATA,
    payload: {
      apiFailure: null,
      games: data.puzzles,
      date: new Date().toLocaleDateString('en-IN'),
    },
  };
}

function gamesDataFailure(error) {
  return {
    type: FETCH_GAMES_FAILURE,
    payload: {
      apiFailure: error,
    },
  };
}

function fetchGamesDataFromFeed(isWapView) {
  // using 6 hours old date, so new data is reflected after 6:00 AM daily
  const date = new Date(new Date() - 6 * 3600000).toLocaleDateString('en-HI');
  return makeRequest.get(
    `${getFeedUrl()}/toi/web/game/game?date=${date}`,
    { isMobile: isWapView },
    'skipfeedengine',
  );
}

export function fetchGamesData(isWapView) {
  return dispatch =>
    fetchGamesDataFromFeed(isWapView)
      .then(data => dispatch(updateGamesData(data.data)))
      .catch(error => dispatch(gamesDataFailure(error)));
}

function fetchGamesListingData(params) {
  const { grxId = '', ssoId = '' } = params;
  const requestParams = {
    params: {},
    headers: {
      grxId,
      ssoId,
    },
  };
  const mWebParam = params.isWapView ? '&isMobile=true' : '';
  let newReqConfig = GAMESLISTINGAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}${mWebParam}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchMetaWidgetData(params) {
  const requestParams = {
    params: {},
  };
  let mWebParam;
  if (params && params.gameType) {
    params.gameType = params.gameType.replace(/-/g, '_');

    if (params.gameType === 'factchecker') {
      params.gameid = 'today';
    }
    if (params.gameid && params.gameid === 'practice') {
      mWebParam = `&pageTn=practicePage&gameType=${params.gameType}`;
    } else if (params.gameid && params.gameid !== 'practice') {
      if (params.gameid && params.gameid === 'today') {
        mWebParam = `&pageTn=todaysGamePlay&gameType=${params.gameType}`;
      } else {
        mWebParam = `&pageTn=previousGamePlay&gameType=${params.gameType}`;
      }
    } else {
      mWebParam = `&pageTn=gameDetails&gameType=${params.gameType}`;
    }
  } else {
    mWebParam = '&pageTn=homePage';
  }
  let newReqConfig = GAMESMETAWIDGETAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}${mWebParam}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchPuzzleData(params) {
  const requestParams = {
    params: {},
  };
  const gameIdParam =
    params &&
    params.gameid &&
    params.gameid !== 'today' &&
    params.gameid !== 'practice'
      ? params.gameid
      : '';
  params.gameType = params.gameType.replace(/-/g, '_');
  let newReqConfig = PUZZFILEDOWNLOADAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }

  const url = `${UNIFIED_FEED_DOMAIN_GLOBAL}${newReqConfig}&gameType=${
    params.gameType
  }&gameId=${gameIdParam}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchFactCheckerData() {
  const requestParams = {
    params: {},
  };
  const url = `${UNIFIED_FEED_RESOURCES_DOMAIN}/games/factchecker/trump-vs-harris/data.json`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchGamesConfigData(params) {
  const requestParams = {
    params: {},
  };
  const mWebParam = params.isWapView ? '&isMobile=true' : '';
  let newReqConfig = GAMESCONFIGAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}${mWebParam}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function recivePuzzleData(data) {
  return {
    type: RECEIVE_PUZZFILEDOWNLOAD_DATA,
    payload: data,
  };
}

function reciveGamesListingData(data) {
  return {
    type: RECEIVE_GAMELISTING_DATA,
    payload: data,
  };
}

function reciveGamesMetaWidgetData(data) {
  return {
    type: RECEIVE_METAWIDGET_DATA,
    payload: data,
  };
}

function reciveGamesConfigData(data) {
  return {
    type: RECEIVE_GAMECONFIG_DATA,
    payload: data,
  };
}

function reciveFactCheckerData(data) {
  return {
    type: RECEIVE_FACTCHECKER_DATA,
    payload: data,
  };
}

export function loadGamesListingData(params, callback) {
  return dispatch =>
    fetchGamesListingData(params)
      .then(data => {
        dispatch(reciveGamesListingData(data.data));
        if (typeof callback === 'function') {
          callback(true);
        }
      })
      .catch(error => {
        dispatch(gamesDataFailure(error));
        if (typeof callback === 'function') {
          callback(false);
        }
      });
}

export function loadPuzzleData(params) {
  return dispatch =>
    fetchPuzzleData(params)
      .then(data => dispatch(recivePuzzleData(data.data)))
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadMetaWidgetData(params) {
  return dispatch =>
    fetchMetaWidgetData(params)
      .then(data => dispatch(reciveGamesMetaWidgetData(data.data)))
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadGamesConfigData(params) {
  return dispatch =>
    fetchGamesConfigData(params)
      .then(data => dispatch(reciveGamesConfigData(data.data)))
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadFactCheckerData(params) {
  return dispatch =>
    fetchFactCheckerData(params)
      .then(data => dispatch(reciveFactCheckerData(data.data)))
      .catch(error => dispatch(gamesDataFailure(error)));
}

function fetchSyncUp(params) {
  const { userName = '', userImageUrl = '', grxId = '', ssoId = '' } = params;
  const postData = {
    ssoId,
    userName,
    userImageUrl,
    grxId,
  };
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${SYNCAPI}`;
  return makeRequest.post(url, postData, 'skipfeedengine');
}

function fetchLeaderBoardData(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const requestParams = {
    params: {},
    headers: {
      grxId,
      ssoId,
    },
  };
  let newReqConfig = LEADERBOARDAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchStreakData(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const requestParams = {
    params: {},
    headers: {
      grxId,
      ssoId,
    },
  };
  let newReqConfig = STREAKAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchPreviousPuzzleData(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameType = '', grxId = '', ssoId = '' } = params;

  const requestParams = {
    params: {},
    headers: {
      grxId,
      ssoId,
    },
  };
  let newReqConfig = PREVIOUSPUZZLEAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}&gameType=${gameType}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchCrosswordState(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameId = '', gameType = '', grxId = '', ssoId = '', state } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${FETCHCROSSWORDSTATE}&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, { state }, { headers });
}

function saveCrosswordState(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const stateData = {
    gridSize: params.gridSize,
    penaltyTimeInMillis: params.penaltyTimeInMillis,
    completionTimeInMillis: params.completionTimeInMillis,
    lastFocussedCell: params.lastFocussedCell,
    state: params.state,
    penaltyPairs: params.penaltyPairs,
  };
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${SAVECROSSWORDSTATE}&pfm=web&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, stateData, { headers });
}

function fetchSudokuState(params) {
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${FETCHCROSSWORDSTATE}&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, {}, { headers });
}

function saveSudokuState(params) {
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const stateData = {
    isPencilModeOn: params.isPencilModeOn,
    gridSize: params.gridSize,
    penaltyTimeInMillis: params.penaltyTimeInMillis,
    completionTimeInMillis: params.completionTimeInMillis,
    penaltyPairs: params.penaltyPairs,
    board: params.board,
    pencilBoard: params.pencilBoard,
    lastFocussedCell: params.lastFocussedCell,
  };
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${SAVECROSSWORDSTATE}&pfm=web&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, stateData, { headers });
}

function fetchLoopaloopState(params) {
  const { gameId = '', grxId = '', ssoId = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${FETCHCROSSWORDSTATE}&gameId=${gameId}&gameType=loop_a_loop`;
  return makeRequest.post(url, {}, { headers });
}

function saveLoopaloopState(params) {
  const { gameId = '', grxId = '', ssoId = '', fv = '', pfm = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const stateData = {
    completionTimeInMillis: params.completionTimeInMillis,
    loopAloopData: params.loopAloopData,
    isAutoCheck: params.isAutoCheck,
  };
  const appParams = fv && pfm ? `&fv=${fv}&pfm=${pfm}` : '&pfm=web';
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${SAVECROSSWORDSTATE}${appParams}&gameId=${gameId}&gameType=loop_a_loop`;
  return makeRequest.post(url, stateData, { headers });
}

function saveConnectState(params) {
  const { gameId = '', grxId = '', ssoId = '', fv = '', pfm = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const stateData = {
    completionTimeInMillis: params.completionTimeInMillis,
    connectData: params.connectData,
  };
  const appParams = fv && pfm ? `&fv=${fv}&pfm=${pfm}` : '&pfm=web';
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${SAVECROSSWORDSTATE}${appParams}&gameId=${gameId}&gameType=connect`;
  return makeRequest.post(url, stateData, { headers });
}

function fetchLocationGuesserState(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${FETCHCROSSWORDSTATE}&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, {}, { headers });
}

function fetchWhoIsThatState(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${FETCHCROSSWORDSTATE}&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, {}, { headers });
}

function saveLocationGuesserState(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const {
    gameId = '',
    gameType = '',
    grxId = '',
    ssoId = '',
    guesses,
  } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const stateData = {
    guesses,
  };
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${SAVECROSSWORDSTATE}&pfm=web&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, stateData, { headers });
}

function saveWhosThatState(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const {
    gameId = '',
    gameType = '',
    grxId = '',
    ssoId = '',
    locatStateData,
  } = params;

  const headers = {
    grxId,
    ssoId,
  };

  const stateData = {
    whosThatData: locatStateData,
  };
  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${SAVECROSSWORDSTATE}&pfm=web&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.post(url, stateData, { headers });
}

function reciveLeaderBoardData(data) {
  return {
    type: RECEIVE_LEADERBOARD_DATA,
    payload: data,
  };
}

function reciveStreakData(data) {
  return {
    type: RECEIVE_STREAK_DATA,
    payload: data,
  };
}

function recivePreviousPuzzleData(data) {
  return {
    type: RECEIVE_PREVIOUSPUZZLE_DATA,
    payload: data,
  };
}

function reciveCrosswordStateFetch(data) {
  return {
    type: RECEIVE_CROSSWORDSTATE_DATA,
    payload: data,
  };
}

function reciveSudokuStateFetch(data) {
  return {
    type: RECEIVE_SUDOKUSTATE_DATA,
    payload: data,
  };
}

function reciveLoopaloopStateFetch(data) {
  return {
    type: RECEIVE_LOOPALOOPSTATE_DATA,
    payload: data,
  };
}

function reciveLocationGuesserStateFetch(data) {
  return {
    type: RECEIVE_LOCATIONGUESSERSTATE_DATA,
    payload: data,
  };
}

function reciveWhoIsThatStateFetch(data) {
  return {
    type: RECEIVE_WHOISTHATSTATE_DATA,
    payload: data,
  };
}

export function loadLeaderBoardData(params) {
  return dispatch =>
    fetchLeaderBoardData(params)
      .then(data =>
        dispatch(
          reciveLeaderBoardData({ ...data.data, gameId: params.gameId }),
        ),
      )
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadStreakData(params) {
  return dispatch =>
    fetchStreakData(params)
      .then(data =>
        dispatch(reciveStreakData({ ...data.data, gameId: params.gameId })),
      )
      .catch(error => dispatch(reciveStreakData({ error })));
}

export function loadPreviousPuzzleData(params) {
  return dispatch =>
    fetchPreviousPuzzleData(params)
      .then(data => dispatch(recivePreviousPuzzleData({ ...data.data })))
      .catch(error => dispatch(recivePreviousPuzzleData({ error })));
}

export function loadCrosswordStateFetch(params) {
  return dispatch =>
    fetchCrosswordState(params)
      .then(data =>
        dispatch(
          reciveCrosswordStateFetch({ ...data.data, gameId: params.gameId }),
        ),
      )
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadCrosswordStateSave(params) {
  return dispatch =>
    saveCrosswordState(params)
      .then(() => {})
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadSudokuStateFetch(params) {
  return dispatch =>
    fetchSudokuState(params)
      .then(data =>
        dispatch(
          reciveSudokuStateFetch({ ...data.data, gameId: params.gameId }),
        ),
      )
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadSudokuStateSave(params) {
  return dispatch =>
    saveSudokuState(params)
      .then(() => {})
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadLoopaloopStateFetch(params) {
  return dispatch =>
    fetchLoopaloopState(params)
      .then(data =>
        dispatch(
          reciveLoopaloopStateFetch({ ...data.data, gameId: params.gameId }),
        ),
      )
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadLoopaloopStateSave(params) {
  return dispatch =>
    saveLoopaloopState(params)
      .then(() => {})
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadConnectStateSave(params) {
  return dispatch =>
    saveConnectState(params)
      .then(() => {})
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadLocationGuesserStateFetch(params) {
  return dispatch =>
    fetchLocationGuesserState(params)
      .then(data =>
        dispatch(
          reciveLocationGuesserStateFetch({
            ...data.data,
            gameId: params.gameId,
          }),
        ),
      )
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadWhoIsThatStateFetch(params) {
  return dispatch =>
    fetchWhoIsThatState(params)
      .then(data =>
        dispatch(
          reciveWhoIsThatStateFetch({
            ...data.data,
            gameId: params.gameId,
          }),
        ),
      )
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadLocationGuesserStateSave(params) {
  return dispatch =>
    saveLocationGuesserState(params)
      .then(() => {})
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadWhosThatStateSave(params) {
  return dispatch =>
    saveWhosThatState(params)
      .then(() => {})
      .catch(error => dispatch(gamesDataFailure(error)));
}

export function loadSyncUp(params) {
  return dispatch =>
    fetchSyncUp(params)
      .then(() => {})
      .catch(error => dispatch(gamesDataFailure(error)));
}

function fetchPracticeData(params) {
  params.gameType = params.gameType.replace(/-/g, '_');

  const { gameType = '', grxId = '', ssoId = '' } = params;

  const requestParams = {
    params: {},
    headers: {
      grxId,
      ssoId,
    },
  };
  let newReqConfig = PRACTICEAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}&gameType=${gameType}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function recivePracticeData(data) {
  return {
    type: RECEIVE_PRACTICE_DATA,
    payload: data,
  };
}

export function loadPracticeData(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  return dispatch =>
    fetchPracticeData(params)
      .then(data => dispatch(recivePracticeData(data.data)))
      .catch(error => dispatch(gamesDataFailure(error)));
}

function fetchGameStatusData(params) {
  params.gameType = params.gameType.replace(/-/g, '_');
  const { gameId = '', gameType = '', grxId = '', ssoId = '' } = params;

  const requestParams = {
    params: {},
    headers: {
      grxId,
      ssoId,
    },
  };
  let newReqConfig = GAMESTATUSAPI;
  if (params.isGameIframe && params.iframeLangSource) {
    newReqConfig = newReqConfig.replace(
      'pc=toi',
      `pc=${params.iframeLangSource ? params.iframeLangSource : 'pc=toi'}${
        params.iframeLang ? `&lang=${params.iframeLang}` : '&lang=1'
      }`,
    );
  }

  const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${newReqConfig}&playAgain=false&fv=1325&gameId=${gameId}&gameType=${gameType}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function reciveGameStatusData(data) {
  return {
    type: RECEIVE_GAME_STATUS_DATA,
    payload: data,
  };
}

export function loadGameStatusData(params) {
  return dispatch =>
    fetchGameStatusData(params)
      .then(data => {
        if (data && data.data && Array.isArray(data.data.items)) {
          if (data && data.data && data.data.hasPlayed) {
            const gameCongratulationsData = data.data.items.filter(
              item => item.tn === 'gameCongratulationsData',
            )[0];
            if (
              gameCongratulationsData &&
              gameCongratulationsData.gameCongratulationsData
            ) {
              dispatch(
                reciveGameStatusData({
                  ...gameCongratulationsData.gameCongratulationsData,
                  gameId: params.gameId,
                }),
              );
            }
          }
        }
      })
      .catch(error => dispatch(reciveGameStatusData({ error })));
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case FETCH_GAMES_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_GAMELISTING_DATA: {
      return {
        ...state,
        gameslisting: action.payload,
      };
    }

    case RECEIVE_METAWIDGET_DATA: {
      return {
        ...state,
        gamesmetawidget: action.payload,
      };
    }
    case RECEIVE_LEADERBOARD_DATA: {
      let leaderboard = state.leaderboard ? { ...state.leaderboard } : {};
      leaderboard = {
        ...leaderboard,
        [action.payload.gameId || 'today']: action.payload,
      };
      return {
        ...state,
        leaderboard,
      };
    }
    case RECEIVE_STREAK_DATA: {
      return {
        ...state,
        streak: action.payload,
      };
    }
    case RECEIVE_GAME_STATUS_DATA: {
      return {
        ...state,
        gameStatus: action.payload,
      };
    }
    case RECEIVE_PREVIOUSPUZZLE_DATA: {
      return {
        ...state,
        previousPuzzle: action.payload,
      };
    }
    case RECEIVE_PUZZFILEDOWNLOAD_DATA: {
      return {
        ...state,
        puzzledata: action.payload,
      };
    }
    case RECEIVE_PRACTICE_DATA: {
      return {
        ...state,
        practice: action.payload,
      };
    }
    case RECEIVE_GAMECONFIG_DATA: {
      return {
        ...state,
        gamesconfig: action.payload,
      };
    }
    case RECEIVE_CROSSWORDSTATE_DATA: {
      return {
        ...state,
        crosswordstate: action.payload,
      };
    }
    case RECEIVE_SUDOKUSTATE_DATA: {
      return {
        ...state,
        sudokustate: action.payload || 'empty',
      };
    }
    case RECEIVE_LOOPALOOPSTATE_DATA: {
      return {
        ...state,
        loopaloopstate: action.payload || 'empty',
      };
    }
    case RECEIVE_LOCATIONGUESSERSTATE_DATA: {
      return {
        ...state,
        locationguesserstate: action.payload || 'empty',
      };
    }
    case RECEIVE_FACTCHECKER_DATA: {
      return {
        ...state,
        factcheckerdata: action.payload || 'empty',
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
